import type { LucideIcon } from 'lucide-react';
import {
  BarChart3, Bell, Building2, CircleUser, CreditCard, Database, Eye, Gauge, HelpCircle, History, Inbox, KeyRound,
  LayoutDashboard, Layers, Lock, LogIn, MailPlus, Receipt, SlidersHorizontal, SunMoon, Tags, UserCheck, UserCog, Users, Wallet,
} from 'lucide-react';

// Symbole der Navigation im Einstellungen-Pop-up (Gestaltung 08.10.2026, GESTALTUNG.md 2.5): je Eintrag ein Symbol vor
// dem Titel, nur zur Orientierung (aria-hidden). Schlüssel sind die Einträge aus seiten.ts: persönliche Bereiche nach
// ihrem Slug, Organisationsbereiche nach ihrem Bereichsschlüssel, dazu sicht, verwaltung und hilfe.
const SYMBOLE = new Map<string, LucideIcon>([
  ['profil', CircleUser], ['zugang', KeyRound], ['mein-team', UserCheck], ['nutzung', Gauge], ['abrechnung', Receipt], ['tarife', Layers],
  ['nachrichten', Inbox], ['benachrichtigungen', Bell], ['praeferenzen', SlidersHorizontal], ['darstellung', SunMoon], ['sicherheit', Lock], ['daten', Database],
  // Plan 1a Welle 0 (MA-01): „Tarif und Kosten“ mit dem Belegsymbol, „KI-Guthaben“ mit der Geldbörse.
  ['members', Users], ['invitations', MailPlus], ['usage', BarChart3], ['plan', Receipt], ['billing', CreditCard],
  ['cost', Wallet], ['company', Building2], ['branding', Tags], ['roles', UserCog], ['sso', LogIn], ['audit', History],
  ['sicht', Eye], ['verwaltung', LayoutDashboard], ['hilfe', HelpCircle],
]);

export function navSymbol(key: string): LucideIcon | null {
  return SYMBOLE.get(key) ?? null;
}
